import React, { useRef } from "react";
import { Journal } from "./JournalsObj";
import { NavLink } from "react-router-dom";
// import { motion } from "framer-motion";

const Journals = () => {
  return (
    <section className="py-16 bg-[#fafafa]">

      {/* Heading */}
      <div className="text-center mb-14 px-4">
        <h1 className="text-2xl sm:text-4xl font-bold text-[#800000]">
          Featured Publications
        </h1>
        <p className="text-gray-500 mt-3 text-sm sm:text-base">
          Showcasing our journey and vision
        </p>
      </div>

      {/* Container */}
      <div
        className="
        flex sm:grid
        sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4
        gap-2 px-4 sm:px-4 lg:px-8
        overflow-x-auto sm:overflow-visible
        snap-x sm:snap-none
        "
      >
        {Journal?.map((item) => (
          <Card key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
};

export default Journals;

const Card = ({ item }) => {
  const ref = useRef();

  // 3D Tilt Effect
  const handleMouseMove = (e) => {
    const card = ref.current;
    const rect = card.getBoundingClientRect();

    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const rotateY = ((x / rect.width) - 0.5) * 20;
    const rotateX = ((y / rect.height) - 0.5) * -20;

    card.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
  };

  const resetTilt = () => {
    ref.current.style.transform = `rotateX(0deg) rotateY(0deg)`;
  };

  return (
    <div
      ref={ref}
      onMouseMove={handleMouseMove}
      onMouseLeave={resetTilt}
      className="
      snap-center flex-shrink-0 w-[240px] sm:w-full
      transition-transform duration-300
      "
      style={{ transformStyle: "preserve-3d" }}
    >
      <div className="group relative rounded-2xl overflow-hidden bg-white shadow-md hover:shadow-2xl transition-all duration-500">

        {/* Image */}
<div className="relative aspect-[3/4] w-full overflow-hidden bg-gray">

  {/* Background Blur (fills empty space nicely) */}
  <img
    src={item?.image}
    alt=""
    className="absolute inset-0 w-full h-full object-cover blur-xl scale-110 opacity-30"
  />

  {/* Main Image */}
  <img
    src={item?.image}
    alt={item?.name}
    className="
      relative z-10
      w-full h-full
      object-contain
    "
  />

  {/* Glass Reflection */}
  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-700">
    <div className="absolute -left-1/2 top-0 w-[200%] h-full bg-gradient-to-r from-transparent via-white/30 to-transparent rotate-12 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>
  </div>

  {/* Slide Button */}
  <div className="
    absolute bottom-0 left-0 w-full
    translate-y-full group-hover:translate-y-0
    transition-all duration-500
    p-4 z-20
  ">
    <NavLink to={item?.url}>
      <button className="
        w-full py-2.5 rounded-xl text-sm font-medium
        bg-gray text-blue
        shadow-lg hover:bg-gray-100
      ">
        View Edition→
      </button>
    </NavLink>
  </div>

</div>

        {/* Content */}
        <div className="p-5">
          <h2 className="text-base sm:text-lg font-semibold text-red text-center line-clamp-2">
            {item.name}
          </h2>
        </div>

      </div>
    </div>
  );
};